import { Message } from 'element-ui';
const goProduce = function() {
    // this.$router.push({
    //     name: "register"
    // });
    Message.warning({
        message: "功能未开放，敬请期待",
        type: "warning",
        duration: 2000
    });
};
export default goProduce;